import { HeadsetIcon } from '@moia-dev/pace-icons'
import {
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@moia-dev/pace-web'

export const HandledByIcon = ({ operatorName }: { operatorName?: string }) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <Icon size={20}>
          <HeadsetIcon
            css={theme => ({ color: theme.semantic.ColorContentReduced })}
          />
        </Icon>
      </TooltipTrigger>
      <TooltipContent>{operatorName}</TooltipContent>
    </Tooltip>
  )
}
